import { createContext, useContext, useState, ReactNode } from "react";

type Filters = {
  department: string | null;
  role: string | null;
};

type FilterContextType = {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  handleChange: (field: keyof Filters, value: string | null) => void;
};

const defaultFilters: Filters = {
  department: null,
  role: null,
};

export const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilterContext must be used within a FilterProvider");
  }
  return context;
};

export const FilterProvider = ({ children }: { children: ReactNode }) => {
  const [filters, setFilters] = useState<Filters>(defaultFilters);

  const handleChange = (field: keyof Filters, value: string | null) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <FilterContext.Provider value={{ filters, setFilters, handleChange }}>
      {children}
    </FilterContext.Provider>
  );
};
